/* eslint-disable no-restricted-globals */
import _ from 'lodash'
import { createOptionCategory, updateOptionCategory } from '../../apis/backend'
import { ERROR_SYNCHRONIZATION_WITH_SHOP, ERROR_UPDATE_PRODUCT_OPTION, ERROR_WRONG_INFORMATIONS, ADDITIONAL, PRODUCT } from '../../constants'
import { isStringNotNull, keyGenerator } from '../../utils/tools'
import { checkIntegrationAccess } from 'src/utils/externalIntegration'

export const updateCategory = ({ target }, component) => {
  component.setState(prevState => {
    const { category } = prevState;
    const { min, max, optionFree } = category;
    const parsedValue = parseInt(target.value, 10);

    const newCategory = {
      ...category,
      [target.id || target.name]: (target.id === 'name' || target.id === 'type') ? target.value : parsedValue,
      multiple: (min <= 1 && max === 1) ? false : category.multiple,
      optionFree: target.id === 'optionFree' ? parsedValue : optionFree,
    };

    if (target.id === 'min' && parsedValue > max) {
      newCategory.max = parsedValue;
    } else if (target.id === 'max' && (parsedValue <= optionFree || parsedValue === 1)) {
      newCategory.optionFree = null;
    }
    if (target.id === 'type') {
      if (target.value === ADDITIONAL) {
        newCategory.additional = true;
        newCategory.type = PRODUCT;
      } else {
        newCategory.additional = null;
        newCategory.type = target.value;
      }
    }

    return { category: newCategory };
  });
};



export const checkMinValue = ({ target }, component, min) => {
  let { value = '' } = target;
  value = parseInt(value, 10);
  if (value < min) {
    target.value = min;
  }
  updateCategory({ target }, component);
}

export const updateRadioButton = ({ target }, component) => {
  component.setState(prevState => {
    const { category } = prevState;
    return {
      category: { ...category, [target.id || target.name]: target.value }
    };
  });
};
export const handleUpdateCategorie = async (component, shopsMenu, isBiborne) => {
  const { openErrorModal, closeModal, createCategorie } = component.props;
  try {
    component.setState({ isLoading: true });
    const { category, synchronize = false } = component.state;
    const { categories } = component.props;
    const {
      max,
      min,
      name,
      multiple = false,
      items = null,
      type,
      optionFree
    } = category;

    const nameToCkeck = name ? name.replace(/\s+/g, '') : '';

    if (nameToCkeck && nameToCkeck.length > 0 && (checkIntegrationAccess('products', 'hasMenuPOS') ? isStringNotNull(type) : true)) {
      const parsedMultiple = JSON.parse(multiple)
      const returnCategory = {
        ...category,
        multiple: parsedMultiple,
        min,
        max: category.max || null,
        position: _.keys(categories).length,
        key: createCategorie ? keyGenerator('OPTION') : category.key,
        items,
        type,
        optionFree: max === 1 && !isBiborne ? null : optionFree,
        multipleMax: parsedMultiple ? Math.min(category.multipleMax, category.max) : null
      };

      if (!synchronize || (synchronize && _.size(shopsMenu) > 1)) {
        if (createCategorie) {
          await createOptionCategory(
            { ...returnCategory, items: undefined },
            Object.keys(shopsMenu || {})
          );
        } else {
          await updateOptionCategory(returnCategory, returnCategory.key, Object.keys(shopsMenu || {}));
        }

        closeModal();
        component.setState({ showModal: false, synchronize: false });
      }
      else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoading: false }) };
    } else {
      openErrorModal(ERROR_WRONG_INFORMATIONS);
    }
  } catch (error) {
    openErrorModal(ERROR_UPDATE_PRODUCT_OPTION);
  }
  component.setState({ isLoading: false });
};